import { Link } from "react-router-dom";
import { useState } from "react";

export default function StoreCard({ store }) {
  const [imgErr, setImgErr] = useState(false);
  const showImg = store.logo_url && !imgErr;
  return (
    <Link
      to={`/store/${store.slug}`}
      data-testid={`store-card-${store.slug}`}
      className="group border border-slate-200 bg-white hover-lift rounded-sm p-5 flex flex-col items-center text-center aspect-square justify-center gap-3"
    >
      <div className="w-16 h-16 flex items-center justify-center bg-white overflow-hidden">
        {showImg ? (
          <img
            src={store.logo_url}
            alt={`${store.name} logo`}
            className="max-w-full max-h-full object-contain"
            loading="lazy"
            onError={() => setImgErr(true)}
          />
        ) : (
          <span className="font-display text-3xl tracking-tighter text-slate-950">
            {store.name?.[0]}
          </span>
        )}
      </div>
      <div>
        <p className="font-display text-sm tracking-tight text-slate-950 group-hover:text-emerald-600">
          {store.name}
        </p>
        <p className="text-xs text-slate-500 mt-1">
          {store.coupon_count} {store.coupon_count === 1 ? "coupon" : "coupons"}
        </p>
      </div>
    </Link>
  );
}
